module.exports = __webpack_public_path__ + "static/pipeline-619dd59a62d60849766641d693cb9c7b.mp4";